export const TENANT_CLASS = Object.freeze({
    FASHION_RETAIL: "fashion_retail",
    GAS_STATION: 'gas_station',
    INDUSTRY: 'industry',
    SUPERMARKET: 'supermarket',
});